import React from 'react';

import { ModalButton, PermissionAccess } from '@portals/framework';
import { AccessLevelEnum } from '@portals/types';

import { StoreListingWizardModalProps } from '../../modals';

export function AddNewProductButton() {
  return (
    <PermissionAccess
      minAccessLevel={AccessLevelEnum.Edit}
      permissionKeys="store_management"
    >
      <ModalButton
        label="Add new product listing"
        modalName="StoreListingWizardModal"
        data-testid="add-new-product-listing-btn"
        data={
          {
            intent: 'create',
            storeListing: undefined,
          } as StoreListingWizardModalProps['data']
        }
      />
    </PermissionAccess>
  );
}
